import React, { useState, useRef, useEffect } from "react";
import { BlueLogo, GoogleIcon } from "../../shared/functional/global-image-import";
import { Button, Form, Image, Icon } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { storeGlobalCodes, storeTags, apiCall, storeUserDetail, storeIsFullEngOpen, logout } from "../../store/actions";
import { useDispatch, useSelector } from 'react-redux';
import ForgotPasswordModal from "../../shared/components/organisms/modal/forgot-password/forgot-password";
import SimpleReactValidator from 'simple-react-validator';
import { commonFunctions, Notifications, Link, env } from "../../shared/functional/global-import";
import { useLocation } from "react-router-dom";
import SideBarDetailConfing from "../../config/sideBar.config"


const LoginPage = () => {
    const history = useHistory();
    const [forgotPasswordStatus, setForgotPasswordStatus] = React.useState(false)
    const [fieldOptions, setFieldOptions] = useState([]);
    const [iconToggle, setIconToggle] = React.useState(false)
    const [, forceUpdate] = useState()
    const simpleValidator = useRef(new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } }))
    const [logInForm, setLogInForm] = useState({ email: "", password: "", rememberMe: false })
    const dispatch = useDispatch();
    const api = useSelector(state => state.api);
    const userDetail = useSelector(state => state.auth.userDetail);
    const search = useLocation().search;
    useEffect(() => {
        dispatch(storeIsFullEngOpen(false));
        if (userDetail?.token) {
            let roleOfUser = userDetail.role
            let isNotAdmins = roleOfUser === "Teacher" ? true : roleOfUser === "School" ? true :
                roleOfUser === "District" ? true : false
            onCheckRoleAndRoute(roleOfUser, userDetail, isNotAdmins)
        }
        else {
            getGlobalCode();
        
        }
    }, []);
    const onHandleChange = (e, { value, data }) => {
        setLogInForm({ ...logInForm, [data]: value })}

    const onCheckBoxChange = (e, { data, checked }) => {
        setLogInForm({ ...logInForm, [data]: checked })
        }
    const onSubmit = (e) => {
        const isFormValid = commonFunctions.onHandleFormSubmit(e, simpleValidator, forceUpdate);
        if (isFormValid) {
            dispatch(apiCall({
                urls: ["LOGIN"], method: "POST", data: logInForm,
                onSuccess: (response) => {
                    // console.log("login response =", response)
                    if (response.isSuccess) {
                        if (response?.roleAndPermission?.roleAndPermission) {
                            const screenList = JSON.parse(response?.roleAndPermission?.roleAndPermission).map((screen, index) => {
                                if (screen.Permissions !== null) {
                                    const permissionlist = JSON.parse(screen.Permissions);
                                    const permissionDetail = permissionlist.map((permission, index) => {
                                        const actionDetails = JSON.parse(permission.Actions ? permission.Actions : null);
                                        return {
                                            ScreenName: permission.ScreenName, screenId: permission.ScreenId, Access: permission.Access, action: actionDetails
                                        }
                                    })
                                    return {
                                        Access: screen.Access, ModuleId: screen.ModuleId, ModuleName: screen.ModuleName, permission: permissionDetail
                                    }
                                }
                                else {
                                    return {
                                        Access: screen.Access, ModuleId: screen.ModuleId, ModuleName: screen.ModuleName, permission: screen.Permissions
                                    }
                                }
                            })
                            response.roleAndPermission = screenList
                        }
                        else {response.roleAndPermission = null}
                        response.teacherId = response?.teacherId === 0 ? null : response?.teacherId
                        let loginUserRole = response.role
                        let isTeacher = loginUserRole === "Teacher" ? true : false
                        response.isTeacher = isTeacher
                        let isNotAdmin = loginUserRole === "Teacher" ? true : loginUserRole === "School" ? true :
                            loginUserRole === "District" ? true : false

                        dispatch(storeUserDetail(response));
                        onCheckRoleAndRoute(loginUserRole, response, isNotAdmin)
                    }
                    getCustomFields();
                    getGlobalCode();
                }, showNotification: true
            }))
        }
    }

    const onCheckRoleAndRoute = (loginUserRole, response, isNotAdmin) => {
        if (loginUserRole === "Admin") {
            history.push(`${env.PUBLIC_URL}/dashboard`);
        }
        else if (loginUserRole === "SubAdmin") {
            let sideBar = loginUserRole && SideBarDetailConfing?.filter((sideObj) => sideObj.role.includes(loginUserRole))
            let moduleName = response.roleAndPermission && response.roleAndPermission.length > 0 && response.roleAndPermission?.filter((item) => {
                return item.Access === 1 && item.permission
            });

            let allowedScreens = []
            moduleName && moduleName.length > 0 && moduleName?.map((item) => {
                item.permission.map((item2) => {
                    if (item2.Access) {
                        allowedScreens.push(item2)
                    }
                    else {
                        return { ...item2 }
                    }
                })
            })
            sideBar = sideBar?.filter((sideObj) => {
                let data = allowedScreens.filter((singleAllowedObj) => {
                    return singleAllowedObj.ScreenName.toLowerCase() === sideObj.route.toLowerCase()
                })
                if (data?.length > 0) {
                    return sideObj
                }
            })
            history.push(`${env.PUBLIC_URL}/${sideBar[0].route}`);
        }
        else if (loginUserRole === "School") {

            response.emailConfirmed ? history.push(`${env.PUBLIC_URL}/teacher-library`) :
                history.push(`${env.PUBLIC_URL}/school-profile`)

        }
        else if (loginUserRole === "District") {
            response.emailConfirmed ? history.push(`${env.PUBLIC_URL}/teacher-library`) :
                history.push(`${env.PUBLIC_URL}/district-profile`)
        }
        else if (isNotAdmin) {
            response.subscriptionExpired ? 
                history.push(`${env.PUBLIC_URL}/complete-your-payment`) :
                history.push(`${env.PUBLIC_URL}/teacher-library`)
        }
        else {
            dispatch(Notifications.show({
                title: "Error",
                message: 'No role assigned',
                position: 'br', autoDismiss: 5
            }, "error"))
            dispatch(logout())
        }
    }
    //*********** Store the tag *************//
    const getCustomFields = () => {
        let tag = [];
        dispatch(apiCall({
            urls: ["ENGAGEMENTCUSTOMFIELDS"], method: "GET", data: {
                pageNo: 1, pageSize: 100, searchValue: "", orderBy: "ModifiedDate", orderByDescending: "true", AllRecords: true},
            onSuccess: (response) => {
                response.map((responseObj) => {
                                                           
                    let tags = responseObj?.tags && JSON.parse(responseObj.tags)
                    const res = tags.map((single) => {
                        return { value: single.TagId, text: single.TagName }
                    });
                    setFieldOptions(fieldOptions => [...fieldOptions, { [responseObj.fieldName]: res }])
                    tag.push({ [responseObj.fieldName]: res })
                })
                dispatch(storeTags(tag));
            }
        }));
    }
    const getGlobalCode = () => {
        dispatch(apiCall({
            urls: ["GLOBALCODELIST"], method: "GET", data: { "categoryId": -1 }, onSuccess: (response) => {
                dispatch(storeGlobalCodes(response));
            }, showNotification: false
        }))
    }
    const forgetPassword = () => {
        setForgotPasswordStatus(!forgotPasswordStatus);
    };
    const passwordToggle = () => {
        setIconToggle(!iconToggle)}
        

    return (
        <div className="login">
            <div className="loginInner">
                <div className='loginInnerBox'>
                    <Image className='logo' src={BlueLogo} />
                    <Form onSubmit={onSubmit}>
                        <Form.Input placeholder="Email" data="email" type="email" name="email"
                            onChange={onHandleChange}
                            error={simpleValidator.current.message('email', logInForm.email, 'required|email')} fluid />
                        <div className="password">
                            <Form.Input type={iconToggle ? "" : "password"} placeholder='Password' data="password" onChange={onHandleChange}
                                error={simpleValidator.current.message('password', logInForm.password, 'required|password')}
                                fluid />
                            {!iconToggle && <Icon title="Show password" name="eye" className="primary-color passwordIcon" onClick={passwordToggle} />}
                            {iconToggle && <Icon title="Hide Password" name="eye slash" className="primary-color passwordIcon" onClick={passwordToggle} />}
                        </div>
                        <div className="forgotPassword">
                            <Form.Checkbox label='Remember me' data="rememberMe" onChange={onCheckBoxChange} />
                            <Link to="#" onClick={forgetPassword}>Forgot Password</Link>
                        </div>
                        <Button className="loginBtn" disabled={api.isApiLoading} loading={api.isApiLoading} fluid>Login</Button>
                    </Form>

                    {/* will do it later don't remove it  */}
                    {/* <p className='or'>Or</p>
                    <Button className='googleBtn' fluid><Image src={GoogleIcon} /><span>Log in with Google</span></Button> */}
                </div>
                <div className='notAccount'>Don't have an account?  <Link className='pointer' to={`${env.PUBLIC_URL}/sign-up-new`} >Sign up</Link></div>
            </div>
            {forgotPasswordStatus &&
                <ForgotPasswordModal openModal={forgotPasswordStatus} closeModal={forgetPassword} />
            }
        </div>
    )
}

export default LoginPage